export interface LocationDto {
  id: number;
  street: string;
  street2?: string | null;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  latitude?: number | null; // decimal
  longitude?: number | null; // decimal
}
